<template>
<div class="trial">
  <header class="trial-logo">
    <div class="logo" />
  </header>
  <div class="content">
    <div class="bgc top"></div>
    <div class="bgc right"></div>
    <div class="bgc left"></div>
    <div class="bgc bottom"></div>
    <div class="trial-form">
    <a-form class="form" :form="form" @submit="handleSubmit">
      <div class="form-title">私有化试用版</div>
      <form-item label="申请人姓名">
        <a-input
          class="trial-input" 
          v-decorator="['applicantName', { 
            rules: [
              { required: true, message: '请输入申请人姓名!' },
              {validator: validatorSpace}
            ] 
            }]"
          placeholder="请输入申请人姓名"
          :maxLength="50"
        />
      </form-item>
      <form-item label="申请人邮箱">
        <a-input
        class="trial-input"
        v-decorator="[
          'email',
          {
            rules: [
              {
                type: 'email',
                message: '邮箱格式不正确!',
              },
              {
                required: true,
                message: '请输入邮箱!',
              },
            ],
          },
        ]"
        placeholder="请输入申请人邮箱"
        :maxLength="50"
      />
      </form-item>
      <form-item label="最终客户">
        <a-input
          class="trial-input"
          v-decorator="['customerName', { 
              rules: [
                 { required: true, message: '请输入最终客户!' },
                {validator: validatorSpace}
              ] 
            }]"
          placeholder="请输入最终客户"
          :maxLength="50"
        />
      </form-item>
      <div class="productWp">
        <form-item label="产品" class="product">
          <a-checkbox-group :options="options" v-decorator="['products', { rules: [{ validator: validateProduct }] }]" />
          <!-- <span class="checkAll">
            <a-checkbox
              :checked="checkAll"
              :indeterminate="indeterminate"
              @change="onCheckAllChange"
            >
              ONE
            </a-checkbox>
          </span> -->
          <!-- <div class="onePanel">
            <a-checkbox-group v-model="checkedList" :options="oneOptions" @change="onPluginChange" />
          </div> -->
        </form-item>
      </div>
      <div :style="{ marginTop: 32 }">
        <a-button type="primary" html-type="submit" class="trial-submit" :loading="loading">
          提交
        </a-button>
      </div>
    </a-form>
    </div>
  </div>
  <div class="trial-footer">
  <footer class="footerText">
    Copyright ©2007-2021 All rights reserved. 北京博睿宏远数据科技股份有限公司
      版权所有 京 ICP备 08104257 号 京公网安备 11010102002419
  </footer>
  </div>
</div>
</template>
<script>
import './Trial.less'
import axiosCommon from '@/api/axiosCommon';
import { randomOrderId } from '@/util/utils.js';
import md5 from 'crypto-js/md5';
import { Layout, Form, Input, Button, Checkbox, message } from 'ant-design-vue';
const { Header, Footer} = Layout;
const { Item } = Form;
import { isArray } from 'lodash';

const options = [
  {label: 'Server', value: 1},
  {label: 'SDK', value: 2},
  {label: 'Browser', value: 3},
  {label: 'Dataview', value: 4},
];

const ONE = 9
const oneOptions = [
  { label: 'ONE-APM', value: 'apm'},
  { label: 'ONE-RUM', value: 'rum'},
  { label: 'ONE-日志计量', value: 'log'},
  { label: 'ONE-指标/数据摄入', value: 'etl'},
  { label: 'ONE-AI中级', value: 'aiM'},
  { label: 'ONE-STM', value: 'stm'},
]

export default {
  data() {
    return {
      loading: false,
      options,
      oneOptions,
      indeterminate: false,
      checkAll: false,
      checkedList: [],
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'trial' })
  },
  methods: {
    // 校验空格
    validatorSpace (rules, value, callback) {
      if(value && value.indexOf(' ') !== -1) {
        callback('不能输入空格');
      } else {
        callback();
      }
    },
    // 校验产品选中
    validateProduct (rules, value, callback) {
      if (value && value.length > 0) {
        callback();
      } else {
        if (this.checkedList && this.checkedList.length > 0) {
          callback();
        } else {
          callback('请至少选择一个产品');
        }
      }
    },
    // 提交
    async handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields( async (err, values) => {
        if (!err) {
          const orderNo = randomOrderId();
          let token = (md5(orderNo + 'bonree').toString()).slice(0, 6).toLowerCase();
          let _products = isArray(values?.products) ? values?.products : []
          let proList = _products.concat([ONE])
          const params ={
            applicantName: values.applicantName,
            email: values.email,
            customerName: values.customerName,
            products: this.checkedList && this.checkedList?.length > 0 ? proList: values?.products,
            orderNo: orderNo,
            token: token,
            plugins: this.checkedList,
          }
          this.loading = true
          const res = await axiosCommon.post('/api/trial', params);
          this.loading = false
          // console.log(res);
          if (res === true) {
            message.success('提交成功!');
          } else {
            message.error(res.msg);
          }
        }
      });
    },
    onCheckAllChange (e) {
        this.checkedList = e.target.checked ? oneOptions.map((item) => item.value) : []
        this.indeterminate = false
        this.checkAll = e.target.checked ? true : false
        this.$nextTick(() => {
          this.form.validateFields(['products'],{ force: true }, (error, values) => {
            console.warn('error', error)
          } );
        });
    },
    onPluginChange (checkedList) {
      const plugins = oneOptions.map((item) => item?.value)
      this.indeterminate = !!checkedList?.length && checkedList?.length < plugins?.length;
      this.checkAll = checkedList?.length === plugins?.length;
      this.$nextTick(() => {
        this.form.validateFields(['products'],{ force: true }, (error, values) => {
          console.warn('error', error)
        } );
      });
    }
  },

  components: {
    Header,
    Footer,
    AForm: Form,
    FormItem: Item,
    AInput: Input,
    AButton: Button,
    ACheckboxGroup: Checkbox.Group,
    ACheckbox: Checkbox,
  },
}

</script>
